(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  ready(function () {
    var compatibilityPanel = document.querySelector('.rental-compatibility-panel');
    var requiredDocumentsPanel = document.getElementById('RentalRequiredDocumentsPanel');
    var uploadDocumentsPanel = document.getElementById('RentalUploadDocumentsPanel');
    var documentsGuidePanel = document.getElementById('RentalDocumentsGuidePanel');

    if (!requiredDocumentsPanel) return;

    function closeOtherPanel(openPanel) {
      if (!openPanel || !openPanel.open) return;

      if (compatibilityPanel && openPanel === compatibilityPanel && requiredDocumentsPanel.open) {
        requiredDocumentsPanel.open = false;
      }

      if (openPanel === requiredDocumentsPanel && compatibilityPanel && compatibilityPanel.open) {
        compatibilityPanel.open = false;
      }
    }

    if (compatibilityPanel) {
      compatibilityPanel.addEventListener('toggle', function () {
        closeOtherPanel(compatibilityPanel);
      });
    }

    requiredDocumentsPanel.addEventListener('toggle', function () {
      closeOtherPanel(requiredDocumentsPanel);
    });

    function closeOtherDocumentPill(openPill, otherPill) {
      if (openPill && openPill.open && otherPill && otherPill.open) {
        otherPill.open = false;
      }
    }

    if (uploadDocumentsPanel) {
      uploadDocumentsPanel.addEventListener('toggle', function () {
        closeOtherDocumentPill(uploadDocumentsPanel, documentsGuidePanel);
      });
    }

    if (documentsGuidePanel) {
      documentsGuidePanel.addEventListener('toggle', function () {
        closeOtherDocumentPill(documentsGuidePanel, uploadDocumentsPanel);
      });
    }
  });
})();
